import axiosInstance from '@/shared/api/axios';
import type {
  ApiCargoIdsConnectPostBody,
  ApiCargoIdsConnectPostResponse,
  ApiCargoIdsGetResponse,
  ApiCargoIdsRequestPostBody,
  ApiCargoIdsRequestPostResponse,
} from '@/shared/types/api/cargo-ids';

export const apiCargoIdsGet = async (): Promise<ApiCargoIdsGetResponse> => {
  const { data } = await axiosInstance.get<ApiCargoIdsGetResponse>('/cargo-ids');
  return data;
};

export const apiCargoIdsRequestPost = async (
  body: ApiCargoIdsRequestPostBody,
): Promise<ApiCargoIdsRequestPostResponse> => {
  const { data } = await axiosInstance.post<ApiCargoIdsRequestPostResponse>(
    '/cargo-ids/request',
    body,
  );
  return data;
};

export const apiCargoIdsConnectPost = async (
  body: ApiCargoIdsConnectPostBody,
): Promise<ApiCargoIdsConnectPostResponse> => {
  const { data } = await axiosInstance.post<ApiCargoIdsConnectPostResponse>(
    '/cargo-ids/connect',
    body,
  );
  return data;
};

export const apiCargoIdDelete = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/cargo-ids/${id}`);
};
